import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';
import vuetify from './plugins/vuetify';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import '@mdi/font/css/materialdesignicons.css';
import VueHtmlToPaper from 'vue-html-to-paper';
// import VuetifyToast from './plugins/vuetify-snackbar';
// import '@/plugins/toast-snackbar.js';
// import VueMoment from 'vue-moment';
import moment from 'moment';

Vue.config.productionTip = false;

moment.locale('es');
Vue.prototype.$moment = moment;

Vue.use(VueHtmlToPaper);

/* eslint-disable no-new */
new Vue({
  vuetify,
  router,
  store,
  render: (h) => h(App),
})
.$mount('#app')
;
